<!-- 专享客服表格页 -->

<template>
  <div class="customersService">
    <div class="box-shadow" v-if="createStep == 1">
      <top-title name="专享客服"></top-title>
      <!-- <div class="tip-box">
        <div>
          <img src="@/assets/images/new_icon_reminder.png" alt="" />
        </div> -->
        <!-- <span>专享客服开通标准：1.自营&FCS开通门槛一一上月咨询量(大于等于1000)
          、上月满意度(大于等于65%)、上月留言率(小于30%)；2.POP开通门槛一一上月最后一天风向标前80%，上月应答率不低于97%</span> -->
      <!-- </div> -->
      <div class="tab-line">
        <div class="tab-item" @click="handleSwitch(1)" :class="{ active: tabIndex == '1' }"
          :style="{ color: tabIndex == '1' ? globalBG : '', 'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '', }">
          发送专享消息
          <span></span>
        </div>
        <!-- <div class="tab-item" @click="handleSwitch(2)" :class="{ active: tabIndex == '2' }" :style="{color: tabIndex == '2' ? globalBG : '','border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',}">
          邀请专享用户
          <span></span>
        </div> -->
      </div>
      <!-- 发送专享消息 -->
      <template v-if="tabIndex == '1'">
        <div class="form-box">
          <el-form ref="formSearch" :inline="true" :model="form1" label-width="120px">
            <el-form-item label="计划名称：">
              <el-input size="small" v-model="form1.activityName" placeholder="请输入计划名称"></el-input>
            </el-form-item>
            <el-form-item label="消息类型：">
              <el-select size="small" v-model="form1.messageType">
                <el-option v-for="(item, index) in messageType" :key="index" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发送方式：">
              <el-select size="small" v-model="form1.sendType">
                <el-option v-for="(item, index) in sendType" :key="index" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发送状态：">
              <el-select size="small" v-model="form1.status">
                <el-option v-for="(item, index) in sendStatus" :key="index" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提交时间：">
              <div class="my_select_time">
                <el-date-picker prefix-icon="no_icon" v-model="form1.commitTimeStart" type="datetime"
                  :placeholder="'选择日期时间'" size="small" format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="commitTimeStartOption" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px" class="time1" :clearable="false"></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker prefix-icon="no_icon" v-model="form1.commitTimeEnd" type="datetime"
                  :placeholder="'选择日期时间'" :picker-options="commitTimeEndOption" size="small"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 145px; font-size: 12px"
                  default-time="23:59:59" class="time2" :clearable="false"></el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime(1)"></i>
                <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
              </div>
            </el-form-item>
            <el-form-item label="发送时间：">
              <div class="my_select_time">
                <el-date-picker prefix-icon="no_icon" v-model="form1.sendTimeStart" type="datetime"
                  :placeholder="'选择日期时间'" size="small" format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="sendTimeStartOption" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px" class="time1" :clearable="false"></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker prefix-icon="no_icon" v-model="form1.sendTimeEnd" type="datetime"
                  :placeholder="'选择日期时间'" :picker-options="sendTimeEndOption" size="small" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width: 145px; font-size: 12px" default-time="23:59:59"
                  class="time2" :clearable="false"></el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime(2)"></i>
                <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
              </div>
            </el-form-item>
            <el-form-item>
              <div class="el-btn">
                <el-button size="small" :disabled="tableLoding" class="search" @click="
      form1.current = 1;
    submitForm(1);
    ">
                  <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
                  查询
                </el-button>
                <el-button size="small" class="reset" @click="resetForm">重置</el-button>
              </div>
            </el-form-item>
          </el-form>
          <div style="padding:10px 30px;">
            <el-button type="primary" style="width: 105px;" @click="createPlanShow(2, 'create')">创建发送计划</el-button>
          </div>
        </div>
        <div class="table-box">
          <el-table ref="table" :data="tableData" tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
            v-loading="tableLoding">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column label="发送计划名称" prop="activityName"></el-table-column>
            <el-table-column label="消息类型" prop="messageType">

              <template slot-scope="scope">
                <div v-if="scope.row.messageType == 1">商品推荐</div>
                <div v-if="scope.row.messageType == 2">图文消息</div>
                <div v-if="scope.row.messageType == 3">文本消息</div>
              </template>
            </el-table-column>
            <el-table-column label="消息内容" width="160">

              <template slot="header" slot-scope="scope">
                <span>消息内容</span>
                <span style="color:#7f85e9;cursor:pointer;" @click="allShow1 = true" v-if="!allShow1">（展开全部）</span>
                <span style="color:#7f85e9;cursor:pointer;" @click="allShow1 = false" v-else>（收起全部）</span>
              </template>

              <template slot-scope="scope">
                <el-tooltip class="item" effect="light"
                  :content="scope.row.messageType == 3 ? scope.row.textMessageContent : scope.row.massTheme"
                  placement="top">
                  <div class="hoveTitle" v-show="!allShow1">
                    <span class="rich_title" @click="showPhone(scope.row)">
                      {{ scope.row.messageType == 3 ? scope.row.textMessageContent : scope.row.massTheme }}
                    </span>
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow1">
                  <span class="rich_title" @click="showPhone(scope.row)">
                    {{ scope.row.messageType == 3 ? scope.row.textMessageContent : scope.row.massTheme }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="发送对象" width="160">

              <template slot="header" slot-scope="scope">
                <span>发送对象</span>
                <span style="color:#7f85e9;cursor:pointer;" @click="allShow2 = true" v-if="!allShow2">（展开全部）</span>
                <span style="color:#7f85e9;cursor:pointer;" @click="allShow2 = false" v-else>（收起全部）</span>
              </template>

              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" :content="showSelectedCrowd(scope.row.selectedCrowd)"
                  placement="top">
                  <div class="hoveTitle" v-show="!allShow2">{{ showSelectedCrowd(scope.row.selectedCrowd) }}</div>
                </el-tooltip>
                <div v-show="allShow2">{{ showSelectedCrowd(scope.row.selectedCrowd) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="发送方式" prop="sendType">

              <template slot-scope="scope">
                <div v-if="scope.row.sendType == 1">定时发送</div>
                <div v-else-if="scope.row.sendType == 2">循环发送</div>
                <div v-else>立即发送</div>
              </template>
            </el-table-column>
            <el-table-column label="提交时间" prop="commitTime" width="160px"></el-table-column>
            <el-table-column label="发送时间" prop="sendTime" width="180px">

              <template slot-scope="scope">
                <div v-if="scope.row.sendType == 2">{{ scope.row.cycleStartTime }}至<br>{{ scope.row.cycleEndTime
                  }}<br>每天{{ scope.row.cycleExecutionTime }}</div>
                <div v-else>{{ scope.row.sendTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="发送状态" prop="status" width="120px">

              <template slot-scope="scope">
                <div>
                  <span class="circle" :class="{ green: scope.row.status == '0' }"></span>
                  <span v-if="scope.row.status == 1">待发送</span>
                  <span v-else-if="scope.row.status == 2">已发送</span>
                  <span v-else-if="scope.row.status == 3">发送失败</span>
                  <span v-else-if="scope.row.status == 4">未开始</span>
                  <span v-else-if="scope.row.status == 5">进行中</span>
                  <span v-else-if="scope.row.status == 6">已结束</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="效果概况">

              <template slot-scope="scope">
                <div>发送: {{ scope.row.sendSubmitNum }}</div>
                <div>触达: {{ scope.row.sendNum }}</div>
                <div>点击: {{ scope.row.clickNum }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200px">

              <template slot-scope="scope">
                <div class="control-button">
                  <el-button class="operation" type="text" @click="createPlanShow(2, 'edit', scope.row)"
                    v-if="[1, 4].includes(Number(scope.row.status))">修改</el-button>
                  <el-button class="operation" type="text" @click="stopSendPlan(scope.row, 1)"
                    v-if="[1, 4, 5].includes(Number(scope.row.status))">终止发送</el-button>
                  <el-button class="operation" type="text" @click="createPlanShow(2, 'copy', scope.row)"
                    v-if="[2, 3, 5, 6].includes(Number(scope.row.status))">再次发送</el-button>
                  <el-button class="operation" type="text" @click="analysisShow(scope.row, 1)"
                    v-if="[2, 3, 5, 6].includes(Number(scope.row.status))">效果分析</el-button>
                  <el-button class="operation" type="text" @click="openSendRecords(scope.row)"
                    v-if="scope.row.sendType == 2">发送记录</el-button>
                  <el-button class="operation" type="text" @click="stopSendPlan(scope.row, 2)"
                    v-if="[3].includes(Number(scope.row.status))">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div>
            <el-pagination background class="pagination" @size-change="handleSizeChange"
              @current-change="handleCurrentChange" :current-page="form1.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="form1.size"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </template>
      <!-- 邀请专享用户 -->

      <template v-if="tabIndex == '2'">
        <div class="form-box">
          <el-form ref="formSearch" :inline="true" :model="form2" label-width="120px">
            <el-form-item label="群发主题：">
              <el-input size="small" v-model="form2.activityName" placeholder="请输入群发主题"></el-input>
            </el-form-item>
            <el-form-item label="发送类型：">
              <el-select size="small" v-model="form2.sendType">
                <el-option v-for="(item, index) in sendType" :key="index" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发送状态：">
              <el-select size="small" v-model="form2.status">
                <el-option v-for="(item, index) in sendStatus" :key="index" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提交时间：">
              <div class="my_select_time">
                <el-date-picker prefix-icon="no_icon" v-model="form2.commitTimeStart" type="datetime"
                  :placeholder="'选择日期时间'" size="small" format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="commitTimeStartOption" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px" class="time1" :clearable="false"></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker prefix-icon="no_icon" v-model="form2.commitTimeEnd" type="datetime"
                  :placeholder="'选择日期时间'" :picker-options="commitTimeEndOption" size="small"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 145px; font-size: 12px"
                  default-time="23:59:59" class="time2" :clearable="false"></el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime(3)"></i>
                <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
              </div>
            </el-form-item>
            <el-form-item label="发送时间：">
              <div class="my_select_time">
                <el-date-picker prefix-icon="no_icon" v-model="form2.sendTimeStart" type="datetime"
                  :placeholder="'选择日期时间'" size="small" format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="sendTimeStartOption" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px" class="time1" :clearable="false"></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker prefix-icon="no_icon" v-model="form2.sendTimeEnd" type="datetime"
                  :placeholder="'选择日期时间'" :picker-options="sendTimeEndOption" size="small" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width: 145px; font-size: 12px" default-time="23:59:59"
                  class="time2" :clearable="false"></el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime(4)"></i>
                <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
              </div>
            </el-form-item>
            <el-form-item>
              <div class="el-btn">
                <el-button size="small" :disabled="tableLoding" class="search" @click="
      form2.current = 1;
    submitForm(2);
    ">
                  <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
                  查询
                </el-button>
                <el-button size="small" class="reset" @click="resetForm">重置</el-button>
              </div>
            </el-form-item>
          </el-form>
          <div style="padding:10px 30px;">
            <el-button type="primary" style="width: 105px;" @click="createPlanShow(3, 'create')">创建邀请计划</el-button>
            <el-button style="width: 105px;" :style="{ 'borderColor': globalBG, 'color': globalBG }"
              @click="showInvitation">提取邀请链接</el-button>
          </div>
        </div>
        <div class="table-box">
          <el-table ref="table" :data="tableData" tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
            v-loading="tableLoding">
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column label="邀请计划名称" prop="activityName"></el-table-column>
            <el-table-column label="消息内容" width="160">

              <template slot="header" slot-scope="scope">
                <span>消息内容</span>
                <span style="color:#7f85e9;cursor:pointer;" @click="allShow1 = true" v-if="!allShow1">（展开全部）</span>
                <span style="color:#7f85e9;cursor:pointer;" @click="allShow1 = false" v-else>（收起全部）</span>
              </template>

              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" :content="scope.row.massTheme" placement="top">
                  <div class="hoveTitle" v-show="!allShow1">
                    <span class="rich_title" @click="showPhone(scope.row)">{{
      scope.row.massTheme }}</span>
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow1">
                  <span class="rich_title" @click="showPhone(scope.row)">{{
      scope.row.massTheme }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="邀请对象" width="160">

              <template slot="header" slot-scope="scope">
                <span>邀请对象</span>
                <span style="color:#7f85e9;cursor:pointer;" @click="allShow2 = true" v-if="!allShow2">（展开全部）</span>
                <span style="color:#7f85e9;cursor:pointer;" @click="allShow2 = false" v-else>（收起全部）</span>
              </template>

              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" :content="showSelectedCrowd(scope.row.selectedCrowd)"
                  placement="top">
                  <div class="hoveTitle" v-show="!allShow2">{{ showSelectedCrowd(scope.row.selectedCrowd) }}</div>
                </el-tooltip>
                <div v-show="allShow2">{{ showSelectedCrowd(scope.row.selectedCrowd) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="发送方式" prop="sendType">

              <template slot-scope="scope">
                <div v-if="scope.row.sendType == 1">定时发送</div>
                <div v-else-if="scope.row.sendType == 2">循环发送</div>
                <div v-else>立即发送</div>
              </template>
            </el-table-column>
            <el-table-column label="提交时间" prop="commitTime" width="160px"></el-table-column>
            <el-table-column label="发送时间" prop="sendTime" width="180px">

              <template slot-scope="scope">
                <div v-if="scope.row.sendType == 2">{{ scope.row.cycleStartTime }}至<br>{{ scope.row.cycleEndTime
                  }}<br>每天{{ scope.row.cycleExecutionTime }}</div>
                <div v-else>{{ scope.row.sendTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="效果概况">

              <template slot-scope="scope">
                <div>发送: {{ scope.row.sendSubmitNum }}</div>
                <div>触达: {{ scope.row.sendNum }}</div>
                <div>点击: {{ scope.row.clickNum }}</div>
              </template>
            </el-table-column>
            <el-table-column label="发送状态" prop="status" width="120px">

              <template slot-scope="scope">
                <div>
                  <span class="circle" :class="{ green: scope.row.status == '0' }"></span>
                  <span v-if="scope.row.status == 1">待发送</span>
                  <span v-else-if="scope.row.status == 2">已发送</span>
                  <span v-else-if="scope.row.status == 3">发送失败</span>
                  <span v-else-if="scope.row.status == 4">未开始</span>
                  <span v-else-if="scope.row.status == 5">进行中</span>
                  <span v-else>已结束</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200px">

              <template slot-scope="scope">
                <div class="control-button">
                  <el-button class="operation" type="text" @click="createPlanShow(3, 'edit', scope.row)"
                    v-if="[1, 4].includes(Number(scope.row.status))">修改</el-button>
                  <el-button class="operation" type="text" @click="stopSendPlan(scope.row, 1)"
                    v-if="[1, 4, 5].includes(Number(scope.row.status))">终止发送</el-button>
                  <el-button class="operation" type="text" @click="createPlanShow(3, 'copy', scope.row)"
                    v-if="[2, 3, 5, 6].includes(Number(scope.row.status))">再次发送</el-button>
                  <el-button class="operation" type="text" @click="analysisShow(scope.row, 2)"
                    v-if="[2, 3, 5, 6].includes(Number(scope.row.status))">效果分析</el-button>
                  <el-button class="operation" type="text" @click="openSendRecords(scope.row)"
                    v-if="scope.row.sendType == 2">发送记录</el-button>
                  <el-button class="operation" type="text" @click="stopSendPlan(scope.row, 2)"
                    v-if="[3].includes(Number(scope.row.status))">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div>
            <el-pagination background class="pagination" @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2" :current-page="form2.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="form2.size"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </template>
    </div>
    <!-- 未开通专享客服提示 -->
    <div class="noPermissionDialog" v-if="noPermissionVisible">
      <div class="dialog_box">
        <div class="dialog_title"><img src="@/assets/images/new_icon_waring_yellow.png" alt="" />提示</div>
        <div class="dialog_content">
          您好，您的店铺暂未开通专享客服，不支持此操作。请先前往客服管家（kf.jd.com），申请开通专享客服。
        </div>
        <div class="dialog_footer">
          <el-button type="primary" @click="kaiTong">去开通</el-button>
        </div>
      </div>
    </div>
    <!-- 创建发送计划 -->
    <create-send-plan v-if="createStep == 2" :sourceType="1" @onBack="backToList"
      :editForm="editForm"></create-send-plan>
    <!-- 创建邀请计划 -->
    <create-send-plan v-if="createStep == 3" :sourceType="2" @onBack="backToList"
      :editForm="editForm"></create-send-plan>
    <!-- 效果分析 -->
    <effect-analysis-x v-if="createStep == 4" :cycleList="cycleList" :officialObj="officialObj"
      @onClose="goBackHomeX"></effect-analysis-x>

    <!-- <=== 弹窗 ===> -->
    <!-- 提取邀请链接 -->
    <el-dialog title="提取邀请链接" width="650px" style="margin-top: 100px;" :visible.sync="getInvitationVisible">
      <div>
        <div class="invitaTips">
          <div><img src="@/assets/images/new_icon_waring_yellow.png" alt="" /></div>
          <div>
            <p>1.邀请链接分为不指定类型和指定开通客服账号类型；</p>
            <p>2.商家可通过客服人员在接待用户咨询时主动发送开通链接邀请用户开通，也可将链接配置在客服机器人的自动回复语及其他店铺免费流量入口中引导用户开通。</p>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <span>链接类型：</span>
          <el-radio v-model="urlRadio" :label="1" @change="urlChange(1)">随机分配</el-radio>
          <el-radio v-model="urlRadio" :label="2" @change="urlChange(2)">指定客服</el-radio>
          <el-select v-model="selectWaiter" placeholder="请选择指定客服" @change="urlChange(2)">
            <el-option v-for="item, index in waiterList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div style="margin-top: 20px;margin-bottom: 40px;">
          <span>邀请链接：</span>
          <el-input style="width: 540px;" v-model="inviteUrl" disabled></el-input>
        </div>
        <div class="dialog_close" style="text-align: center;">
          <el-button @click="getInvitationVisible = false">关闭</el-button>
          <el-button id="copyBtn" type="primary" @click="copyUrl">复制</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 终止发送计划 -->
    <el-dialog title="提示" width="400px" style="margin-top: 150px;" :visible.sync="stopPlanVisible">
      <div class="dialog_tips" style="padding-left: 10px;padding-bottom: 10px;">
        <img src="@/assets/images/new_icon_waring_yellow.png" alt="" />
        你是否确认终止发送计划？
      </div>
      <div class="dialog_close">
        <el-button @click="stopPlanVisible = false">取消</el-button>
        <el-button type="primary" @click="stopPlanSure">确定</el-button>
      </div>
    </el-dialog>
    <!-- 删除发送计划 -->
    <el-dialog title="提示" width="400px" style="margin-top: 150px;" :visible.sync="delPlanVisible">
      <div class="dialog_tips" style="padding-left: 10px;padding-bottom: 10px;">
        <img src="@/assets/images/new_icon_waring_yellow.png" alt="" />
        你是否确认删除发送计划？
      </div>
      <div class="dialog_close">
        <el-button @click="delPlanVisible = false">取消</el-button>
        <el-button type="primary" @click="delPlanSure">确定</el-button>
      </div>
    </el-dialog>
    <!-- 发送记录 -->
    <el-dialog title="发送记录" width="750px" style="margin-top: 100px;" :visible.sync="sendRecordsVisible">
      <div>
        <span>发送时间：</span>
        <div class="my_select_time">
          <el-date-picker prefix-icon="no_icon" v-model="sendRecordsForm.sendTimeStart" type="datetime"
            :placeholder="'选择日期时间'" size="small" format="yyyy-MM-dd HH:mm:ss" :picker-options="sendStartTimeOption"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 120px; font-size: 12px" class="time1"
            :clearable="false"></el-date-picker>
          <div class="time_to_text" style="margin-top: 1px !important">
            至
          </div>
          <el-date-picker prefix-icon="no_icon" v-model="sendRecordsForm.sendTimeEnd" type="datetime"
            :placeholder="'选择日期时间'" :picker-options="sendEndTimeOption" size="small" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 145px; font-size: 12px" default-time="23:59:59"
            class="time2" :clearable="false"></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime(5)"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
        <el-button type="primary" style="margin-left:10px;" @click="recordSearch(1)">查询</el-button>
        <el-button class="reset" @click="recordSearch(0)">重置</el-button>
      </div>
      <div style="margin-top: 30px">
        <el-table ref="table" :data="recordsTableData" tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          v-loading="recordsTableLoading">

          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column label="发送时间" prop="sendTime"></el-table-column>
          <el-table-column label="发送人数" prop="sendNum"></el-table-column>
          <el-table-column label="触达人数" prop="reachNum"></el-table-column>
          <el-table-column label="点击人数" prop="clickNum"></el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div>
          <el-pagination background class="pagination" @size-change="handleSizeChange3"
            @current-change="handleCurrentChange3" :current-page="sendRecordsForm.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="sendRecordsForm.size"
            layout="total, sizes, prev, pager, next, jumper" :total="total3"></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 短信预览 -->
    <sendPhoneDongdong v-if="sendPhoneShow" @close="sendPhoneShow = false" :isShow="sendPhoneShow"
      :formData="sendPhoneFormData" :moduleType="moduleType" />
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { getExclusiveWaiterList, isOpen, recycleSendRecordPage, exclusiveWaiterDetail, stopExclusiveWaiterPlan, deleteActivity, activityCycleList, getWaiterList, insertExculusiveCrowd } from "@/api/marketing/dongdong";
import topTitle from "@/components/top-title.vue";
import createSendPlan from "./components/create-send-plan.vue"; // 创建发送计划
import effectAnalysisX from "@/components/effect-analysis-x.vue"; // 效果分析
import sendPhoneDongdong from "@/components/send-phone-dongdong"; // 短信预览
import { mapState } from "vuex";
export default {
  name: "group_chart_market",
  components: {
    topTitle,
    createSendPlan,
    effectAnalysisX,
    sendPhoneDongdong,
  },
  data() {
    return {
      tabIndex: "1",
      createStep: 1,
      // 记录查询条件
      form1: {
        current: 1,
        size: 10,
        source: 0,
        activityName: "",
        messageType: "",
        sendType: "",
        status: "",
        commitTimeStart: "",
        commitTimeEnd: "",
        sendTimeStart: "",
        sendTimeEnd: "",
      },
      form2: {
        current: 1,
        size: 10,
        source: 1,
        activityName: "",
        sendType: "",
        status: "",
        commitTimeStart: "",
        commitTimeEnd: "",
        sendTimeStart: "",
        sendTimeEnd: "",
      },
      sendRecordsForm: {
        id: "",
        sendTimeStart: "",
        sendTimeEnd: "",
        current: 1,
        size: 10,
      },
      recordsTableData: [],
      recordsTableLoading: false,
      allShow1: false, // 展开全部
      allShow2: false, // 展开全部
      total: 0,
      total3: 0,
      // 消息类型
      messageType: [
        { label: "全部", value: "" },
        { label: "商品推荐", value: "1" },
        { label: "图文消息", value: "2" },
        { label: "文本消息", value: "3" },
      ],
      // 发送方式
      sendType: [
        { label: "全部", value: "" },
        { label: "立即发送", value: "0" },
        { label: "定时发送", value: "1" },
        { label: "循环发送", value: "2" },
      ],
      // 发送状态 1待发送 2已发送 3发送失败4未开始 5进行中 6已结束
      sendStatus: [
        { label: "全部", value: "" },
        { label: "待发送", value: "1" },
        { label: "已发送", value: "2" },
        { label: "发送失败", value: "3" },
        { label: "未开始", value: "4" },
        { label: "进行中", value: "5" },
        { label: "已结束", value: "6" },
      ],
      tableData: [],
      tableLoding: false,
      commitTimeStartOption: {
        disabledDate: (date) => {
          var endTime
          if (this.tabIndex == 1) {
            endTime = this.form1.commitTimeEnd;
          } else {
            endTime = this.form2.commitTimeEnd;
          }
          var time = date.getTime();
          var isDisabled = false;
          if (endTime) {
            isDisabled = time > new Date(endTime).getTime();
          }
          return isDisabled;
        }
      },
      commitTimeEndOption: {
        disabledDate: (date) => {
          var startTime
          if (this.tabIndex == 1) {
            startTime = this.form1.commitTimeStart;
          } else {
            startTime = this.form2.commitTimeStart;
          }
          var time = date.getTime();
          var isDisabled = false;
          if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
          }
          return isDisabled;
        }
      },
      sendTimeStartOption: {
        disabledDate: (date) => {
          var endTime
          if (this.tabIndex == 1) {
            endTime = this.form1.sendTimeStart;
          } else {
            endTime = this.form2.sendTimeStart;
          }
          var time = date.getTime();
          var isDisabled = false;
          if (endTime) {
            isDisabled = time > new Date(endTime).getTime();
          }
          return isDisabled;
        }
      },
      sendTimeEndOption: {
        disabledDate: (date) => {
          var startTime
          if (this.tabIndex == 1) {
            startTime = this.form1.sendTimeEnd;
          } else {
            startTime = this.form2.sendTimeEnd;
          }
          var time = date.getTime();
          var isDisabled = false;
          if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
          }
          return isDisabled;
        }
      },
      sendStartTimeOption: {
        disabledDate: (date) => {
          var endTime = this.sendRecordsForm.sendTimeEnd
          var time = date.getTime();
          var isDisabled = false;
          if (endTime) {
            isDisabled = time > new Date(endTime).getTime();
          }
          return isDisabled;
        }
      },
      sendEndTimeOption: {
        disabledDate: (date) => {
          var startTime = this.sendRecordsForm.sendTimeStart
          var time = date.getTime();
          var isDisabled = false;
          if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
          }
          return isDisabled;
        }
      },
      rowData: {},
      editForm: {}, // 计划回显数据
      getInvitationVisible: false, // 提取邀请链接弹窗
      stopPlanVisible: false, // 终止发送计划弹窗
      delPlanVisible: false, // 删除发送计划弹窗
      noPermissionVisible: false, // 未开通专享客服提示弹窗
      sendRecordsVisible: false, // 发送记录弹窗
      sendPhoneShow: false, // 短信预览弹窗
      sendPhoneFormData: {}, // 短信预览弹窗展示数据
      moduleType: 1, // 预览弹窗类型
      urlRadio: 1, // 邀请链接类型
      waiterList: [], // 客服列表
      inviteUrl: "", // 邀请链接
      selectWaiter: "", // 选择的客服
      cycleList: [], // 效果分析执行周期信息
    };
  },
  created() {
    // 调用埋点接口
    this.buriedPoint(1, '专享客服', '客户营销', '咚咚群聊')
  },
  mounted() {
    this.isOpen(status => {
      if (status == true) {
        this.noPermissionVisible = false
      } else {
        this.noPermissionVisible = true
      }
      if (!this.noPermissionVisible) {
        this.initData();
        if (this.$route.query.source) {
          this.officialObj = {
            outerId: this.$route.query.outerId - 0,
            source: this.$route.query.source,
            sendTime: this.$route.query.sendTime,
          };
          if (this.$route.query.cycleList != "") {
            this.cycleList = JSON.parse(this.$route.query.cycleList)
          }
          this.createStep = 4
        }
      }
    })
  },

  methods: {
    showSelectedCrowd(selectedCrowd) {
      var res = "";
      if (selectedCrowd) {
        res = "选择人群: ";
        var includeCrowd = selectedCrowd.includeCrowd;
        var includeSearchId = selectedCrowd.includeSearchId;
        if (includeCrowd && includeCrowd.length > 0) {
          selectedCrowd.includeCrowd.forEach((item, index) => {
            var name = item.name;
            if (index != "0") {
              name = "," + name;
            }
            res += name;
          });
        }
        if (includeSearchId && includeSearchId.length > 0) {
          selectedCrowd.includeSearchId.forEach((item, index) => {
            var name = item.name;
            if (index != "0") {
              name = "," + name;
            }
            res += name;
          });
        }

        res += " 关系：";
        res += selectedCrowd.includeRule == 1 ? "合并; " : "交集; ";
      }
      if (selectedCrowd && selectedCrowd.excludeFlag == "1") {
        var excludeP = " 排除人群：";
        var excludeRuleStr = selectedCrowd.excludeRule == 1 ? "合并" : "交集";
        var excludeCrowd = selectedCrowd.excludeCrowd;
        var excludeSearchId = selectedCrowd.excludeSearchId;
        if (excludeCrowd && excludeCrowd.length > 0) {
          excludeCrowd.forEach((item, index) => {
            var name = item.name;
            if (index != "0") {
              name = "," + name;
            }
            excludeP += name;
          });
        }
        if (excludeSearchId && excludeSearchId.length > 0) {
          excludeSearchId.forEach((item, index) => {
            var name = item.name;
            if (index != "0") {
              name = "," + name;
            }
            excludeP += name;
          });
        }
        excludeP += "  关系：" + excludeRuleStr;
        res += "     " + excludeP;
      }
      return res;
    },
    // 查询是否开通专属客服
    isOpen(callBack) {
      isOpen().then(res => {
        console.log(res,"=========>");
        if(res.data && res.data.code == 0){
          this.$message.warning(res.data.message)
        }else if(res.code == 0){
          this.$message.warning(res.message)
        }
        callBack(res.data)
      }).catch(err => {
        console.log(err,'=========err');
        callBack(res)
      })
    },
    // 创建发送计划按钮
    // step:步骤 2为发送计划,3为邀请计划   type:类型
    createPlanShow(step, type, row) {
      if (type == "create") {
        // if (this.tabIndex == 1) {
        //   insertExculusiveCrowd().then(res => { })
        // }
        this.editForm = {}
        this.createStep = step
        return
      }
      exclusiveWaiterDetail(row.id).then(res => {
        if (res.code == 1) {
          this.editForm = res.data
          this.editForm.id = row.id
          if (type == "copy") {
            this.editForm.isCopy = true
          }
          this.createStep = step
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 返回列表
    backToList(val) {
      this.createStep = 1
      this.resetForm()
    },
    // 打开手机预览
    showPhone(row) {
      this.moduleType = this.tabIndex
      this.sendPhoneFormData = row
      this.sendPhoneShow = true
    },
    // 查看效果分析
    analysisShow(row, type) {
      row.source = "DONGDONG_MARKETING_BATCH";
      activityCycleList(row.id).then(res => {
        let data = res.data
        let routeUrl = this.$router.resolve({
          path: "/marketing/chat/exclusiveCustomersService",
          query: {
            outerId: data.length ? data[0].id : "",
            source: row.source,
            sendTime: row.sendTime,
            cycleList: row.sendType == 2 ? JSON.stringify(data) : ""
          },
        });
        window.open(routeUrl.href, "_blank");
      })
    },
    goBackHomeX() {
      // 返回列表清空地址栏携带的参数，防止刷新后回到效果分析页
      let url = window.location.href.split("?")[0]
      window.history.replaceState({
        path: url
      }, '', url)
      this.createStep = 1
    },
    // 切换tab
    handleSwitch(index) {
      this.tabIndex = index;
      this.form1.current = 1
      this.form2.current = 1
      this.getTableData();
    },
    initData() {
      // this.form1.sendStartTime = this.getDateStr(0) + " 00:00:00";
      // this.form1.sendEndTime = this.getDateStr(90) + " 23:59:59";
      this.getTableData();
    },
    // 重置
    resetForm() {
      if (this.tabIndex == 1) {
        for (var key in this.form1) {
          this.form1[key] = "";
        }
        this.form1["current"] = 1;
        this.form1["size"] = 10;
        this.form1["source"] = 0;
      } else if (this.tabIndex == 2) {
        for (var key in this.form2) {
          this.form2[key] = "";
        }
        this.form2["current"] = 1;
        this.form2["size"] = 10;
        this.form2["source"] = 1;
      }
      this.getTableData();
    },
    submitForm(type) {
      this.getTableData();
    },
    // 查询
    getTableData() {
      let params = {}
      if (this.tabIndex == 1) {
        params = { ...this.form1 }
      } else if (this.tabIndex == 2) {
        params = { ...this.form2 }
      }
      this.tableLoding = true
      getExclusiveWaiterList(params).then((res) => {
        this.tableLoding = false;
        if (res.code === 1) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 提取邀请链接弹窗
    showInvitation() {
      this.inviteUrl = `https://fpage.jd.com/exService?venderId=${this.$store.getters.loginUserInfo.venderId}`
      this.urlRadio = 1
      this.selectWaiter = ""
      getWaiterList({ isPrimary: false }).then(res => {
        if (res.code == 1) {
          this.waiterList = res.data
        }
      })
      this.getInvitationVisible = true
    },
    urlChange(val) {
      if (val == 1) {
        this.inviteUrl = `https://fpage.jd.com/exService?venderId=${this.$store.getters.loginUserInfo.venderId}`
      } else {
        if (this.urlRadio == 2) {
          if (!this.selectWaiter) {
            this.inviteUrl = ""
            return
          }
          this.inviteUrl = `https://fpage.jd.com/exService?venderId=${this.$store.getters.loginUserInfo.venderId}&openSource=1&waiter=${this.selectWaiter}`
        }
      }
    },
    copyUrl() {
      let that = this
      let clipboard = new Clipboard("#copyBtn", {
        text(trigger) {
          //返回字符串
          return that.inviteUrl;
        },
      });
      // 复制成功
      clipboard.on("success", (e) => {
        that.$message.success("复制成功")
        clipboard.destroy();
      });
    },
    // 打开终止/删除计划弹窗
    stopSendPlan(row, type) {
      this.rowData = row
      if (type == 1) {
        this.stopPlanVisible = true
      } else {
        this.delPlanVisible = true
      }
    },
    // 终止计划
    stopPlanSure() {
      stopExclusiveWaiterPlan(this.rowData.id).then(res => {
        if (res.code == 1) {
          this.$message.success(res.message)
          this.submitForm()
        } else {
          this.$message.error(res.message)
        }
        this.stopPlanVisible = false
      }).catch(err => {
        console.log(err);
        this.$message.error(err.message)
        this.stopPlanVisible = false
      })
    },
    // 删除计划
    delPlanSure() {
      deleteActivity(this.rowData.id).then(res => {
        if (res.code == 1) {
          this.$message.success(res.message)
          this.submitForm()
        } else {
          this.$message.error(res.message)
        }
        this.delPlanVisible = false
      }).catch(err => {
        this.$message.error(err.message)
        this.delPlanVisible = false
      })
    },
    // 打开发送记录弹窗
    openSendRecords(row) {
      this.sendRecordsForm.id = row.id
      this.recordSearch(0)
      this.sendRecordsVisible = true
    },
    recordSearch(type) {
      if (type == 0) {
        this.sendRecordsForm.sendTimeStart = ""
        this.sendRecordsForm.sendTimeEnd = ""
        this.sendRecordsForm.current = 1
        this.sendRecordsForm.size = 10
      }
      this.getRecords()
    },
    getRecords() {
      this.recordsTableLoading = true;
      recycleSendRecordPage(this.sendRecordsForm).then(res => {
        this.recordsTableLoading = false;
        this.recordsTableData = res.data.records
        this.total3 = res.data.total
      })
    },
    // 清除时间
    clearTimeSendTime(type) {
      if (type == 1) {
        this.form1.commitTimeStart = '';
        this.form1.commitTimeEnd = '';
      } else if (type == 2) {
        this.form1.sendTimeStart = '';
        this.form1.sendTimeEnd = '';
      } else if (type == 3) {
        this.form2.commitTimeStart = '';
        this.form2.commitTimeEnd = '';
      } else if (type == 4) {
        this.form2.sendTimeStart = '';
        this.form2.sendTimeEnd = '';
      } else if (type == 5) {
        this.sendRecordsForm.sendTimeStart = '';
        this.sendRecordsForm.sendTimeEnd = '';
      }
    },
    // 分页
    handleSizeChange(size) {
      this.form1.size = size;
      this.getTableData();
    },
    handleCurrentChange(current) {
      this.form1.current = current;
      this.getTableData();
    },
    handleSizeChange2(size) {
      this.form2.size = size;
      this.getTableData();
    },
    handleCurrentChange2(current) {
      this.form2.current = current;
      this.getTableData();
    },
    handleSizeChange3(size) {
      this.recordsTableData.size = size;
      this.getRecords();
    },
    handleCurrentChange3(current) {
      this.recordsTableData.current = current;
      this.getRecords();
    },
    kaiTong() {
      window.open("https://kf.jd.com")
    },
    removeQueryStringParameter(uri, key) {
      var re = new RegExp("([&]?)" + key + "=.*?(&|$)", "i");
      var separator = uri.indexOf('?') !== -1 ? "&" : "?";
      if (uri.match(re)) {
        return uri.replace(re, '');
      }
    }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
};
</script>

<style lang="scss" scoped>
.circle {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  vertical-align: middle;
  background-color: #ffb95e;
  margin-right: 8px;

  &.green {
    background-color: #49c568;
  }
}

.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}

.customersService {
  position: relative;
  margin: 11px 20px;
  min-width: 1220px;

  .tip-box {
    background: #FAFAFA;
    margin: 0 28px;
    color: #333333;
    border-radius: 3px;
    // height: 48px;
    line-height: 18px;
    padding: 12px;
    display: flex;

    span {
      vertical-align: middle;
    }

    img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 8px;
    }
  }

  .tab-line {
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;

    .tab-item {
      // padding: 15px 0;
      text-align: center;
      width: 106px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;

      // &:first-child{
      //   margin-right: 22px;
      // }
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }

      &.active {
        border-top: 2px;

        span {
          display: block;
          background: #fff;
        }
      }
    }
  }
}

/** 群发记录  */
.form-box {
  padding-top: 20px;

  .el-input,
  .el-select {
    width: 280px;
  }

  /deep/.el-form-item__label {
    padding-right: 0;
  }

  /deep/.el-form-item {
    margin-right: 10px;
    margin-bottom: 16px;

    &:nth-child(4) {
      // margin-right: 0;
    }
  }

  .el-btn {
    padding-left: 50px;

    .search {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;

      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }

    .reset {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;

      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
}

.table-box {
  padding: 4px 28px 0 28px;
  min-height: 500px;
}

.pagination {
  text-align: right;
  padding: 50px 0;
}

.control-button {
  display: flex;
  flex-wrap: wrap;

  .el-button {
    width: auto;
    margin-left: 0 !important;
    padding: 0 !important;
  }

  .operation {
    cursor: pointer;
    color: #7f85e9;
    margin-right: 10px;

    &:hover {
      color: #fe4d45;
    }
  }
}

.question_icon {
  width: 14px;
  height: 14px;
  color: #fe4d45 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #fe4d45;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;

  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}

.dialog_close {
  margin-top: 20px;
  text-align: right;
}

.dialog_tips {
  img {
    vertical-align: middle;
    margin-top: -4px;
  }
}

.invitaTips {
  display: flex;
  background: #fdf6ec;
  color: #EA850B;
  padding: 10px;
  line-height: normal;
  margin-top: -20px;

  >div:nth-of-type(1) {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;

    img {
      width: 16px;
      // margin-left: 6px;
    }
  }
}

.noPermissionDialog {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog_box {
    width: 450px;
    height: 210px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    padding: 30px;
    margin-top: -200px;

    .dialog_title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      height: 30px;

      img {
        width: 16px;
        margin-right: 10px;
      }
    }

    .dialog_content {
      line-height: 24px;
      margin-top: 8px;
      height: 80px;
      color: #333
    }

    .dialog_footer {
      text-align: right;

      .btn {
        background-color: #409eff;
        border-color: #409eff;
        color: #ffffff
      }

      .btn:hover {
        background-color: #66b1ff;
        border-color: #66b1ff !important;
      }
    }
  }
}

.hoveTitle {
  text-align: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hoveTitleShowMore {
  white-space: normal;
}

.rich_title {
  color: #7f85e9;
  font-size: 14px;
  cursor: pointer;
}
</style>